import * as React from "react";
import {
  Text,
  View,
  Image,
  Dimensions,
  // Modal, a part of cleaner code
  StyleSheet,
  Platform,
  TouchableHighlight,
} from "react-native";
//  import { useState } from "react"; a part of cleaner code
import { useNavigation } from "@react-navigation/native";
import TransactionList from "../../components/TransactionList";
import TransactionListWide from "../../components/TransactionListWide";
import { loadTransactions } from "../../redux/actions/TransactionActions";
import { useSelector } from "react-redux";
import GlobalStyles from "../../components/GlobalStyles";
// import CustomIcon from "../components/CustomIcon"; a part of cleaner code
// import TransactionsFilterForm from "../components/TransactionsFilterForm"; a part of cleaner code
import MenuBar from "../../components/headers/MenuBar";
import StatusBar from "../../components/headers/StatusBar";
import { ScrollView } from "react-native-gesture-handler";
import LaunchFilterButton from "../../components/LaunchFilterButton";
import InviteWebHeader from "../../components/InviteWebHeader";
const loadingIcon = require("../../assets/res/Loading_Screen_blue.gif");
const sparkle = require("../../assets/res/sparkle_Alpha_LOOP.gif");
export default function SpendingInsightsScreen() {
  var transactionsLoaded = useSelector(
    (state) => state.transaction.transactionsLoaded
  );
  if (!transactionsLoaded) loadTransactions();
  const navigation = useNavigation();
  // const transactions = useSelector((state) => state.transaction.processedTransactions);
  // const transactionsLoaded = useSelector((state) => state.transaction.transactionsLoaded);
  var earnedAmount =
    useSelector((state) => state.user.userData.balance.amountInvested) || 0;
  var pendingAmount =
    useSelector((state) => state.user.userData.balance.amountInvestedPending) ||
    0;
  var confirmedAmount =
    useSelector(
      (state) => state.user.userData.balance.amountInvestedConfirmed
    ) || 0;
  //var pendingAmount = "0"; //need to replace with value calced from parnter data
  var earnedAmount = Number.parseFloat(earnedAmount);
  var pendingAmount = Number.parseFloat(pendingAmount);
  var confirmedAmount = Number.parseFloat(confirmedAmount);

  var modalVisible = useSelector(
    (state) => state.uistate.transactionFilterModal
  );
  const win = Dimensions.get("window");
  // const [modalVisible, setModalVisible] = useState(false);
  return (
    <View style={GlobalStyles.containerMB}>
      {win.width > 768 ? (
        <View style={styles.headerContainerWhite}>
          <View style={styles.fullHeaderBarY}>
            <MenuBar data="3" />
            <View style={GlobalStyles.headerContainerKLYellow}>
              <View style={GlobalStyles.headerTextYellow}>
                <Text style={GlobalStyles.headingStyle}>
                  Transactions
                </Text>
                <Text style={GlobalStyles.subheaderStyleWeb}>
                  Transactions can take up to 24 hours to appear. The rebate based on
                  purchase price ex GST.
                </Text>
              </View>
              {/* <InviteWebHeader /> */}
            </View>
          </View>
          <View style={styles.wHeaderTextContainer}>
            <View style={styles.wHeaderMiddleContainer}>
              <View style={styles.investedBox}>
                <Image style={styles.sparkleW} source={sparkle} />
                <Text style={styles.Amount}>
                  $
                  {earnedAmount
                    .toFixed(2)
                    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
                </Text>
                <Text style={styles.subText}>TOTAL EARNED</Text>
              </View>
            </View>
            <View style={styles.wHeaderMiddleContainer}>
              <View style={styles.donatedBoxWeb}>
                <Text style={styles.Amount}>
                  $
                  {confirmedAmount
                    .toFixed(2)
                    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
                </Text>
                <Text style={styles.subText}>CONFIRMED REWARDS</Text>
              </View>
            </View>
            <View style={styles.wHeaderMiddleContainer}>
              <View style={styles.pendingBoxWeb}>
                <Text style={styles.Amount}>
                  $
                  {pendingAmount
                    .toFixed(2)
                    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
                </Text>
                <Text style={styles.subText}>PENDING</Text>
              </View>
            </View>
            <View style={styles.wHeaderLeftContainer}>
              <View style={styles.rightBox}>
                <LaunchFilterButton />
              </View>
            </View>
          </View>
        </View>
      ) : (
        <View style={styles.headerContainer}>
          <View style={GlobalStyles.fullHeaderBarW}>
            <StatusBar data="F" />
            <View style={GlobalStyles.headerContainerKLSpend}>
              <View style={[GlobalStyles.headerText]}>
                <Text style={GlobalStyles.headingStyle}>Transactions</Text>
                <Text style={GlobalStyles.subheaderStyle}>
                  Transactions can take up to 24 hours to appear. Rebate based on
                  purchase price ex GST.
                </Text>
              </View>
              <View style={styles.headerSavingsBox}>
                <View style={styles.investedBox}>
                  <Image style={styles.sparkle} source={sparkle} />
                  <Text style={styles.Amount}>
                    $
                    {earnedAmount
                      .toFixed(2)
                      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
                  </Text>
                  <Text style={styles.subText}>TOTAL EARNED</Text>
                </View>

                <View style={styles.donatedBox}>
                  <Text style={styles.Amount}>
                    $
                    {confirmedAmount
                      .toFixed(2)
                      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
                  </Text>
                  <Text style={styles.subText}>CONFIRMED REWARDS</Text>
                </View>

                <View style={styles.pendingBox}>
                  <Text style={styles.AmountPending}>
                    $
                    {pendingAmount
                      .toFixed(2)
                      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")}
                  </Text>
                  <Text style={styles.subText}>PENDING</Text>
                  <TouchableHighlight
                    activeOpacity={0.5}
                    underlayColor="rgba(0,0,0,0.5)"
                    onPress={() =>
                      navigation.navigate("SpendingInsightsAboutPending")
                    }
                  >
                    <View style={styles.optionPromo}>
                      <Text style={styles.optionPromoText}>?</Text>
                    </View>
                  </TouchableHighlight>
                </View>
              </View>
            </View>
          </View>
        </View>
      )}
       {!transactionsLoaded ? (
        <View style={styles.LoadingContainer}>
          <Image style={styles.loadingImage} source={loadingIcon} />
        </View>
      ) : (
        <>
      <View style={styles.bodyContainer}>
       {win.width > 768 ?  <TransactionListWide />  : <TransactionList />}
      </View>
        </>
      )}
    </View>
  );
}
const styles = StyleSheet.create({
  // full screen image background styles
  backgroundContainerBlue: {
    flex: 1,
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
  },
  headerContainer: {
    height: 190,
    zIndex: 5,
  },
  headerContainerWhite: {
    height: 300,
    maxHeight: 300,
    backgroundColor: "#ffffff",
    // borderBottomLeftRadius: 80,
    zIndex: 5,
  },

  LoadingContainer: {
    height: "100%",
    flex:1,
    alignItems: "center",
    justifyContent : "center",
  },
  loadingImage: {
    height: 50,
    width: 50,
  },

  fullHeaderBarY: {
    flex: 1,
    // borderBottomLeftRadius: 80,
    // backgroundColor: "#FFC72C",
    // maxHeight: 280,
    // height: 280,
  },
  wHeaderTextContainer: {
    flex: 1,
    //borderBottomLeftRadius: 80,
    flexDirection: "row",
    backgroundColor: "#FFFFFF",
    maxHeight: 80,
    height: 80,
    maxWidth: 600,
    width: "100%",
    alignSelf: "center",
    justifyContent: "space-evenly",
  },
  wHeaderRightContainer: {
    flex: 40,
    alignContent: "flex-end",
    alignSelf: "center",
  },
  wHeaderMiddleContainer: {
    flex: 10,
    alignSelf: "center",
    marginTop: 10,
  },
  wHeaderLeftContainer: {
    flex: 10,
    alignSelf: "center",
    marginTop: 20,
  },
  yHeaderTextContainer: {
    flex: 1,
    flexDirection: "row",
  },
  yHeaderLeftContainer: {
    flex: 2,
    alignSelf: "center",
    paddingLeft: 100,
  },
  yHeaderRightContainer: {
    flex: 2,
    flexDirection: "row",
    alignSelf: "center",
    alignContent: "space-between",
  },
  optionPromo: {
    alignContent: "center",
    top: 3,
    left: 0,
    height: 15,
    width: 15,
    borderRadius: 25,
    backgroundColor: "#2B587A",
    alignSelf: "center",
  },
  optionPromoText: {
    alignSelf: "center",
    paddingTop: 2,
    color: "#ffffff",
    fontFamily: "montserrat-bold",
    fontSize: 10,
  },
  optionText: {
    paddingTop: 3,
    alignSelf: "flex-start",
    color: "#ffffff",
    fontFamily: "montserrat-bold",
    fontSize: 18,
  },
  closeBottom: {
    color: "red",
  },
  headerText: {
    position: "absolute",
    top: 0,
    left: 50,
    width: "100%",
  },
  filterBox: {
    flex: 1,
    flexDirection: "row",
    paddingTop: 8,
    alignItems: "flex-end",
  },
  filterBoxA: {
    flex: 10,
  },
  filterBoxB: {
    flex: 2,
  },
  filterText: {
    fontFamily: "montserrat-regular",
    fontSize: 8,
    textAlign: "right",
    marginBottom: 5,
  },
  bodyStyle: {
    fontFamily: "montserrat-regular",
    fontSize: 12,
    textAlign: "left",
    marginBottom: 5,
  },
  headerSavingsBox: {
    flex: 1,
    flexDirection: "row",
    width: "100%",
    paddingTop: 65,
  },
  headerSavingsBoxYellow: {
    flexDirection: "row",
    paddingLeft: 30,
    marginTop: -10,
    alignItems: "flex-end",
  },
  SavingsBox: {
    flex: 1,
    alignItems: "flex-end",
    width: "100%",
  },
  investedBox: {
    flex: 3,
    alignItems: "flex-end",
    padding: 5,
    width: "100%",
  },
  donatedBox: {
    flex: 3,
    alignItems: "center",
    padding: 5,
    width: "100%",
    paddingLeft: 10,
  },
  pendingBox: {
    flex: 3,
    alignItems: "center",
    alignContent: "center",
    flexDirection: "column",
    padding: 5,
  },
  donatedBoxWeb: {
    flex: 3,
    alignItems: "flex-end",
    padding: 5,
    width: "100%",
    paddingLeft: 10,
  },
  pendingBoxWeb: {
    flex: 3,
    alignItems: "flex-end",
    alignContent: "center",
    flexDirection: "column",
    padding: 5,
  },

  Amount: {
    fontFamily: "montserrat-bold",
    fontSize: 20,
    textAlign: "right",
    marginBottom: 5,
    color: "#4EBDEF",
  },

  AmountPending: {
    fontFamily: "montserrat-bold",
    fontSize: 20,
    textAlign: "right",
    marginBottom: 5,
    color: "#998FA2",
  },
  subText: {
    fontFamily: "montserrat-regular",
    fontSize: 8,
    textAlign: "center",
    color: "#998FA2",
  },
  bodyContainer: {
    paddingTop: 12,
    flex: 1,
    zIndex: 2,
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    // backgroundColor:"red"
  },
  sparkle: {
    position: "absolute",
    top: -2,
    right: -9,
    width: 17,
    height: 17,
  },
  sparkleW: {
    position: "absolute",
    top: -4,
    right: -9,
    width: 17,
    height: 17,
  },
  rightBox: {
    flex: 1,
    alignItems: "flex-end",
  },

});
